import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import LoadingAnimation from "../components/LoadingAnimation";


export default function PaymentPage() {
  const { orderId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const requestId = location.state?.requestId || null;
  const notificationId = location.state?.notificationId || null;

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
const [searchParams] = useSearchParams();
const tokenFromUrl = searchParams.get("token");
const [paymentStarted, setPaymentStarted] = useState(false);

const isMobile = /Android|iPhone/i.test(navigator.userAgent);
useEffect(() => {

  const init = async () => {

    // 🔥 STEP 1: SET TOKEN FIRST
    if (tokenFromUrl) {
      sessionStorage.setItem("accessToken", tokenFromUrl);
    }

    // 🔥 STEP 2: FETCH ORDER
    try {
      const res = await axiosInstance.get(`/order/${orderId}/`);
      setOrder(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }

  };

  init();

}, [orderId, tokenFromUrl]);
  // 🔒 Disable back
  useEffect(() => {
    const handlePop = (e) => {
      e.preventDefault();
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePop);

    return () => {
      window.removeEventListener("popstate", handlePop);
    };
  }, []);

  // Fetch order


  // 🔥 AUTO PAYMENT START (MOST IMPORTANT)
useEffect(() => {
  if (!order || paymentStarted) return;

  setPaymentStarted(true);

  const startPayment = async () => {
    try {
      const res = await axiosInstance.post("/create-order/", {
        internal_order_id: order.id,
      });

      const data = res.data;


console.log("ORDER DATA =", order);
console.log("RAZORPAY RESPONSE =", data);





const options = {
  key: process.env.REACT_APP_RAZORPAY_KEY_ID,
  amount: Math.round(Number(data.amount) * 100),
  currency: data.currency,
  order_id: data.razorpay_order_id,
	method: {
    netbanking: !isMobile
  },

  handler: function (response) {
  window.location.href = `/payment-success?order_id=${order.id}&razorpay_payment_id=${response.razorpay_payment_id || ""}&notification_id=${notificationId || ""}`;
},

  modal: {
    ondismiss: function () {
      window.location.replace("/orders");
    }
  }
};
      if (!window.Razorpay) {
  alert("Razorpay SDK not loaded");
  return;
}

const rzp = new window.Razorpay(options);
rzp.on("payment.failed", function (response) {
  console.log("❌ PAYMENT FAILED FULL:", response);
  alert(response.error.description || "Payment failed");
});
rzp.open();

    } catch (err) {
      console.error("Payment error:", err);
      alert("Payment start failed");
    }
  };

  startPayment();

}, [order, paymentStarted]);

  if (loading) return <LoadingAnimation />;
  if (!order) return <p>Order not found</p>;

  if (order.payment_status === "paid") {
    window.location.replace("/orders");
    return null;
  }

  const total = order.payable_amount || 0;

  return (
    <div style={{ textAlign: "center", marginTop: 50 }}>
      <h2>💳 Processing Payment...</h2>
      <p>Please wait, do not press back</p>
      <p>Amount: ₹{total}</p>
    </div>
  );
}
